import { localStoragePrefix } from '@studio/constants/env-variables';

export const CUSTOMER_CACHE_KEY = `${localStoragePrefix}-recent-customers`;
export const CUSTOMER_FAVORITE_KEY = `${localStoragePrefix}-favorite-customers`;

export const SEARCH_BY = {
  ORG_NAME: 'ORG_NAME',
  USER_NAME: 'USER_NAME',
  PHONE_NUMBER: 'PHONE_NUMBER',
} as const;
